import React, { useEffect, useRef, useState } from "react"
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  ResourcesDirective,
  ResourceDirective,
  TimelineViews,
} from "@syncfusion/ej2-react-schedule"
import { createElement } from "@syncfusion/ej2-base"
import { Internationalization, isNullOrUndefined } from "@syncfusion/ej2-base"
import {
  DropDownList,
  MultiSelect,
  CheckBoxSelection,
} from "@syncfusion/ej2-dropdowns"
import {
  DropDownListComponent,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns"
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs"
import { ButtonComponent } from "@syncfusion/ej2-react-buttons"
import {
  DatePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars"

import { Header } from "../../UI"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { useQuery } from "react-query"
import { capitalize, upperCase } from "lodash"
import {
  assignEmployee,
  getBookingByDates,
  reminderMail,
  reminderMessage,
} from "../../../axios/api/apiModule"
import { openToastify } from "../../store/actions/toastifyAction"
import {
  REDUX_STORE_DEFAULTS,
  REDUX_TOASTIFY_DEFAULTS,
} from "../../store/config"
import "./styles.css" // Import the CSS file
import { bookingAction } from "../../store/actions/bookingAction"
import { extend } from "@syncfusion/ej2-base"
import Loader from "../../../components/asserts/Spin.gif"
import CreateBooking from "../../UI/createBooking/CreateBooking"
import useSSEListener from "../../../utils/useSSE"
import {
  getAgendaBookingHTML,
  getAgendaBookingHTMLShop,
} from "./calendarEventComponent/EventRender"

// eslint-disable-next-line react/destructuring-assignment
const PropertyPane = (props) => <div className="mt-5">{props.children}</div>

const Scheduler = () => {
  const scheduleObj = useRef(null)
  const calendarView = localStorage.getItem("calendarView")
  const [currentView, setCurrentView] = useState(
    window.innerWidth < 768 ? "Day" : calendarView,
  )
  let { sseConnection } = useSelector((state) => state.userReducer)
  let { employeeListData } = useSelector((state) => state.employeeReducer)
  let { allBookingData, isBookingUpdated } = useSelector(
    (state) => state.bookingReducer,
  )
  const dispatch = useDispatch()
  // Refs for MultiSelect components
  const empAssignObj = useRef(null)
  const [isEventData, setIsEventData] = useState({})
  const [newAssignEmp, setNewAssignEmp] = useState({})
  const [isAssEmpLoading, setIsAssEmpLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isForm, setIsForm] = useState(false)
  const [isData, setIsData] = useState()
  const [isEditData, setIsEditData] = useState(false)
  const [isEmployee, setIsEmployee] = useState(false)
  const [isBookingStatusSlide, setIsBookingStatusSlide] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date())

  //change in calender or booking
  const change = (args) => {
    scheduleObj.selectedDate = args.value
    scheduleObj.dataBind()
  }

  const onDragStart = (arg) => {
    // eslint-disable-next-line no-param-reassign
    arg.navigation.enable = true
  }

  useEffect(() => {
    localStorage.setItem("calendarView", currentView)
  }, [currentView])

  const [calendarData, setCalendarData] = useState([])

  //formatBookingData
  const formatBookingData = (data) => {
    return data.map((allBookingData) => {
      const {
        _id,
        firstName,
        lastName,
        phoneNumber,
        email,
        bookingStatus,
        locationType,
        bookingDate,
        bookingSlot,
        booking,
        isWaterAvailable,
        isElectricityAvailable,
        totalAmount,
        empAssigned,
        createdAt,
        location,
        shortBookingId,
        note,
      } = allBookingData

      const description = `
Customer: ${firstName} ${lastName}
Phone: ${phoneNumber}
Email: ${email}
Location: ${locationType === "shop" ? "Shop" : location || "N/A"}

Services Details:-
${booking
  .map((b) => {
    const serviceInfo = `- ${b.service.serviceOption} - ${b.service.categoryName} / ${b.service.packageName} - $${b.servicePrice}`

    const addonsInfo =
      b.addonService && b.addonService.length > 0
        ? b.addonService
            .map((a) => `${a.addonServiceName} - $${a.addonSalePrice}`)
            .join(",\n")
        : ""

    const imagesInfo =
      b.images && b.images.length > 0
        ? b.images
            .map((image, index) => `Image ${index + 1}: ${image}`)
            .join(",\n")
        : ""

    return `${serviceInfo}${
      addonsInfo ? `; \nAddon Services:- \n${addonsInfo}` : ""
    }`
  })
  .join(";\n\n")}

- Water Available: ${isWaterAvailable ? "Yes" : "No"}
- Electricity Available: ${isElectricityAvailable ? "Yes" : "No"}

Total Amount: $${totalAmount}

Note: ${note || "N/A"}
`.trim()

      // ✅ Start & End time (using bookingDate + bookingSlot)
      const startTime = moment(
        `${bookingDate} ${bookingSlot}`,
        "YYYY-MM-DD HH:mm",
      )
      const endTime = moment(startTime).add(1, "hours")

      const newCreated = moment(createdAt)

      // Extract all image URLs
      const images = booking.flatMap((b) => b.images || [])

      return {
        Id: _id,
        Subject: `${moment(startTime).format("HH:mm A")} ${firstName} #${shortBookingId}`,
        Description: description,
        Location: locationType,
        StartTime: startTime.toISOString(),
        EndTime: endTime.toISOString(),
        Status: bookingStatus,
        empAssigned,
        CreatedAt: newCreated.toISOString(),
        Images: images,
        allBookingData,
      }
    })
  }

  //fetch booking data
  const formatDate = (date) => {
    return date.toISOString().split("T")[0]
  }
  const getDateRangeFromScheduler = (selectedDate) => {
    const start = new Date(selectedDate)
    start.setDate(start.getDate() - 1)

    const end = new Date(selectedDate)
    end.setDate(end.getDate() + 2)

    return {
      startDate: formatDate(start),
      endDate: formatDate(end),
    }
  }
  const fetchAllBookingsByDateRange = async (
    startDate,
    endDate,
    locationType,
    pageSize = 20,
  ) => {
    let page = 1
    let allBookings = []
    let hasMore = true

    while (hasMore) {
      const payload = {
        page,
        pageSize,
        startDate,
        endDate,
        locationType,
      }

      const res = await getBookingByDates(payload)

      if (!res?.success) break

      const orders = res.data?.orders || []
      const pagination = res.data?.pagination

      allBookings = [...allBookings, ...orders]

      hasMore = pagination?.hasNextPage
      page += 1
    }

    return allBookings
  }
  useEffect(() => {
    const handleFetchData = async (params) => {
      setIsLoading(true)
      const { startDate, endDate } = getDateRangeFromScheduler(new Date())
      const allData = await fetchAllBookingsByDateRange(
        startDate,
        endDate,
        "shop",
      )
      setCalendarData(formatBookingData(allData ?? []))
      setIsLoading(false)
    }
    handleFetchData()
  }, [])

  useSSEListener((message) => {
    if (message.type === "showBookingAdmin:update") {
      const info = message.payload
      const newData = formatBookingData([info])

      if (info.locationType === "shop") {
        setCalendarData((prev) => [...newData, ...prev])
      }
    }

    if (message.type === "showBookingStatusAdmin:update") {
      const info = message.payload
      const bookingId = info._id

      setCalendarData((prev) => {
        const index = prev.findIndex(
          (b) => b?.allBookingData?._id === bookingId || b.Id === bookingId,
        )

        // ❌ Do nothing if booking not found
        if (index === -1) return prev

        const updated = [...prev]

        updated[index] = {
          ...updated[index],
          allBookingData: {
            ...updated[index].allBookingData,
            bookingStatus: info.bookingStatus,
          },
          Status: info.bookingStatus, // if calendar uses Status field
        }

        return updated
      })
    }
  })
  // END - fetch booking Data

  useEffect(() => {
    console.log(isEventData, "isEventData", calendarData)
  }, [isEventData, calendarData])

  //update booking
  const update = () => {
    dispatch(
      bookingAction(
        REDUX_STORE_DEFAULTS.UPDATE_BOOKING_DATA(),
        !isBookingUpdated,
      ),
    )
  }

  // Calendar onPopupOpen
  const onPopupOpen = (args) => {
    // console.log("onPopupOpen", args)
    const data = args.data
    setIsEventData(data)
    if (args.type === "Editor") {
      // console.log(args.data, "args.data")
      setTimeout(() => {
        const saveButton = args.element.querySelector("#Save")
        const cancelButton = args.element.querySelector("#Cancel")
        // const checkBox = args.element.querySelector('#check-box');
        // checkBox.onchange = () => {
        //   if (!checkBox.checked) {
        //     saveButton.setAttribute('disabled', '');
        //   } else {
        //     saveButton.removeAttribute('disabled');
        //   }
        // };
        saveButton.onclick = () => {
          const employees = args.data.empAssigned
          const note = args.data.note
          console.log("saveButton", employees, note)
        }
        cancelButton.onclick = () => {
          scheduleObj.current.closeEditor()
        }
      }, 100)
    }
  }

  // Calendar onActionBegin
  const onActionBegin = (args) => {
    // console.log(args, "args.requestType")
    if (args?.requestType === "eventChange") {
      if (args.data.note && args.data.empAssigned.length) {
        // console.log(args.data.empAssigned, args.data.note)
        if (isEmployee) {
          const employees = args.data.empAssigned
          const note = args.data.note
          // handleAssign(employees, note)
          console.log(employees, note)
        }
        if (isBookingStatusSlide) {
        }
      }
    }
  }
  const onEventClick = (args) => {
    console.log("onEventClick", args.event)
    const data = args.event
    // setIsEventData(data)
  }

  const onClickAdd = () => {
    setIsForm(true)
    // scheduleObj.current.addEvent(Data);
  }
  const edit = (id) => {
    calendarData.map((booking) => {
      if (booking._id === id) {
        setIsData(booking)
      }
    })
    setIsForm(true)
    setIsEditData(true)
  }
  const closeEdit = () => {
    if (isForm) {
      setIsData()
      setIsForm(false)
    }
    setIsEditData(false)
  }

  //Editor Template
  const getStatusColor = (status, location, isAppbooking) => {
    const statusColors = {
      pending: "#cc9d51", // yellow
      processing: "#ffb878", // yellow
      confirmed:
        location === "shop"
          ? isAppbooking
            ? "#0B8043"
            : "#10B981"
          : isAppbooking
            ? "#3F51B5"
            : "#5484ed", // green for shop, white otherwise
      completed: "#ababab", // gray
      cancelled: "#dc2127", // red
    }
    return statusColors[status] || "#000000"
  }
  const onEventRendered = (args) => {
    const event = args.data
    const booking = event.allBookingData

    // Apply background color from event data
    // if (event.Color) {
    //   args.element.style.backgroundColor = event.Color
    //   args.element.style.borderRadius = "8px"
    //   args.element.style.color = "#fff"
    //   args.element.style.padding = "4px"
    // }

    args.element.style.backgroundColor = "transparent"
    // Replace default content with custom HTML
    args.element.innerHTML = getAgendaBookingHTMLShop(booking, getStatusColor)
  }
  const editorHeaderTemplate = (props) => {
    return (
      <div id="event-header">
        {isEventData !== undefined ? (
          isEventData?.Subject ? (
            <div>{isEventData?.Subject}</div>
          ) : (
            <div>Create New Event</div>
          )
        ) : (
          <div></div>
        )}
      </div>
    )
  }
  const EditorTemplate = (props) => {
    return props !== undefined ? (
      <div className="relative">
        <table
          className="custom-event-editor"
          style={{ width: "100%" }}
          cellPadding={5}
        >
          <tbody>
            <tr>
              <td>
                <div className="w-full">
                  <span className="e-textlabel">Subject</span>
                  <input
                    id="Subject"
                    className="e-field e-input"
                    type="text"
                    name="Subject"
                    style={{ width: "100%" }}
                    readOnly
                    value={isEventData.Subject}
                  />
                </div>
              </td>
              <td>
                <div className="w-full flex justify-end space-x-3">
                  {/* <span className="e-textlabel">Status</span>
                  <DropDownListComponent
                    id="Status"
                    placeholder="Choose status"
                    data-name="Status"
                    className="e-field"
                    style={{ width: "100%" }}
                    dataSource={[
                      { text: "Confirmed", value: "confirmed" },
                      { text: "Processing", value: "processing" },
                      { text: "Cancelled", value: "cancelled" },
                      { text: "Completed", value: "completed" },
                    ]}
                    fields={{ text: "text", value: "value" }}
                    readonly
                  /> */}
                  <ButtonComponent
                    id="assignEmp"
                    title="assignEmp"
                    onClick={() => {
                      setIsEmployee(true)
                    }}
                  >
                    Employee
                  </ButtonComponent>
                  <ButtonComponent
                    id="bookingStatus"
                    title="bookingStatus"
                    onClick={() => {
                      setIsBookingStatusSlide(true)
                    }}
                  >
                    Status
                  </ButtonComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="w-full">
                  <span className="e-textlabel">Created At</span>
                  <DateTimePickerComponent
                    id="CreatedAt"
                    format="dd/MM/yy hh:mm a"
                    data-name="CreatedAt"
                    value={new Date(isEventData?.CreatedAt)}
                    className="e-field"
                    readonly
                  />
                </div>
              </td>
              <td>
                <div className="w-full">
                  <span className="e-textlabel">From</span>
                  <DateTimePickerComponent
                    id="StartTime"
                    format="dd/MM/yy hh:mm a"
                    data-name="StartTime"
                    value={new Date(isEventData?.StartTime)}
                    className="e-field"
                    readonly
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <span className="e-textlabel">Description</span>
                <textarea
                  id="Description"
                  className="e-field e-input"
                  name="Description"
                  rows={10}
                  cols={50}
                  style={{
                    width: "100%",
                    height: "60px !important",
                    resize: "vertical",
                  }}
                  readOnly
                  value={isEventData.Description}
                />
              </td>
            </tr>
            {isEventData.Images?.length > 0 && (
              <tr>
                <td colSpan={4}>
                  <span className="e-textlabel">Images</span>
                  <div className="flex w-[100%] overflow-x-scroll">
                    {isEventData.Images?.map((url) => {
                      return (
                        <>
                          <img src={url} alt="" className="w-48" />
                          {/* <img
                          src="https://res.cloudinary.com/dsprifizw/image/upload/v1723882081/uploads/image_a6ebd44c24f9.jpg"
                          alt=""
                          className="w-48"
                        /> */}
                        </>
                      )
                    })}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {isEmployee && (
          <div className="absolute inset-0 bg-white space-y-2">
            <button
              className="flex items-center underline"
              onClick={() => {
                setIsEmployee(false)
              }}
            >
              <svg
                className="size-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                />
              </svg>
              <span>Back</span>
            </button>
            <div className="space-y-2">
              <span className="e-textlabel">Employee</span>
              <MultiSelectComponent
                id="mtselement"
                placeholder="Choose Employee"
                data-name="empAssigned"
                className="e-field"
                style={{ width: "100%" }}
                allowObjectBinding={true}
                value={
                  isEventData.empAssigned &&
                  isEventData.empAssigned.map((emp) => emp.empId)
                }
                dataSource={employeeListData ?? []}
                fields={{ text: "name", value: "empId" }}
                mode="CheckBox"
              >
                <Inject services={[CheckBoxSelection]} />
              </MultiSelectComponent>
            </div>
            <div className="space-y-2">
              <span className="e-textlabel">Note to Employee</span>
              <textarea
                id="note"
                className="e-field e-input"
                name="note"
                rows={2}
                cols={50}
                onChange={(e) => {}}
                style={{
                  width: "100%",
                  height: "60px !important",
                  resize: "vertical",
                }}
              />
            </div>
          </div>
        )}

        {isBookingStatusSlide && (
          <div className="absolute inset-0 bg-white space-y-2">
            <button
              className="flex items-center underline"
              onClick={() => {
                setIsBookingStatusSlide(false)
              }}
            >
              <svg
                className="size-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                />
              </svg>
              <span>Back</span>
            </button>
            <div className="space-y-3 divide-y-1">
              <div className="space-y-2">
                <span className="e-textlabel">Status</span>
                <DropDownListComponent
                  id="Status"
                  placeholder="Choose status"
                  data-name="Status"
                  className="e-field"
                  style={{ width: "100%" }}
                  value={isEventData.Status}
                  dataSource={[
                    { text: "Confirmed", value: "confirmed" },
                    { text: "Processing", value: "processing" },
                    { text: "Cancelled", value: "cancelled" },
                    { text: "Completed", value: "completed" },
                  ]}
                  fields={{ text: "text", value: "value" }}
                />
              </div>
              <div className="space-y-2">
                <span className="e-textlabel">Note to Customer</span>
                <textarea
                  id="note"
                  className="e-field e-input"
                  name="note"
                  rows={2}
                  cols={50}
                  onChange={(e) => {}}
                  style={{
                    width: "100%",
                    height: "60px !important",
                    resize: "vertical",
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    ) : (
      <div></div>
    )
  }
  const editorFooterTemplate = (props) => {
    return (
      <div id="event-footer">
        <div id="right-button">
          <button
            id="Save"
            className="e-control e-btn e-primary"
            data-ripple="true"
          >
            Save
          </button>
          <button
            id="Cancel"
            className="e-control e-btn e-primary"
            data-ripple="true"
          >
            Cancel
          </button>
        </div>
      </div>
    )
  }

  //Quick Info Template
  const getHeaderDetails = (data) => {
    // Format the date in full format (e.g., Wednesday, August 17, 2024)
    const fullDate = moment(data.StartTime).format("dddd, MMMM D, YYYY")

    // Format the start and end times in hh:mm A format (e.g., 09:00 AM)
    const startTime = moment(data.StartTime).format("hh:mm A")
    const endTime = moment(data.EndTime).format("hh:mm A")

    // Combine the formatted date and time range
    return `${fullDate} (${startTime} - ${endTime})`
  }
  const headerTemplate = (props) => {
    return (
      <div className="quick-info-header text-white m-5">
        <div className="quick-info-header-content">
          <div className="quick-info-title">{props.Subject}</div>
          <div className="duration-text">
            {getHeaderDetails(props.StartTime)}
          </div>
        </div>
      </div>
    )
  }
  const contentTemplate = (props) => {
    return (
      <div className="quick-info-content">
        {props.elementType === "cell" ? (
          <div className="e-cell-content">
            {/* <div className="content-area">
              <TextBoxComponent id="title" placeholder="Title" />
            </div>
            <div className="content-area">
              <DropDownListComponent
                id="eventType"
                fields={{ text: "Name", value: "Id" }}
                placeholder="Choose Type"
                index={0}
                popupHeight="200px"
              />
            </div>
            <div className="content-area">
              <TextBoxComponent id="notes" placeholder="Notes" />
            </div> */}
          </div>
        ) : (
          <div className="event-content">
            <div className="flex justify-between space-x-3">
              <label>Subject:</label>
              <span className="font-semibold">{props.Subject}</span>
            </div>
            <div className="flex justify-between space-x-3">
              <label>Status:</label>
              <span className="font-semibold capitalize">{props.Status}</span>
            </div>
            {props.empAssigned?.length > 0 && (
              <div className="flex justify-between space-x-3">
                <label>Employee:</label>
                {props.empAssigned.map((emp) => (
                  <span className="font-semibold capitalize">{emp}</span>
                ))}
              </div>
            )}
            <div className="flex justify-between space-x-3">
              <label>Description:</label>
              <span className="font-semibold">{props.Description}</span>
            </div>
            {props.Images?.length > 0 && (
              <div className="flex space-x-3">
                <span className="e-textlabel">Images</span>
                <div className="flex w-[100%] overflow-x-scroll">
                  {props.Images?.map((url) => {
                    return (
                      <>
                        <img src={url} alt="" className="w-24" />
                      </>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
  const footerTemplate = (props) => {
    return (
      <div className="quick-info-footer">
        {props.elementType == "cell" ? (
          <div className="cell-footer">
            <ButtonComponent
              id="more-details"
              cssClass="e-flat"
              content="More Details"
              onClick={() => {}}
            />
            <ButtonComponent
              id="add"
              cssClass="e-flat"
              content="Add"
              isPrimary={true}
              onClick={() => {}}
            />
          </div>
        ) : (
          <div className="event-footer">
            <ButtonComponent
              id="delete"
              cssClass="e-flat"
              content="Delete"
              onClick={() => {}}
            />
            <ButtonComponent
              id="more-details"
              cssClass="e-flat"
              content="More Details"
              isPrimary={true}
              onClick={() => {}}
            />
          </div>
        )}
      </div>
    )
  }

  const onPopupClose = (args) => {
    console.log("onPopupClose", args)
    setIsBookingStatusSlide(false)
    setIsEmployee(false)
  }

  //handleResize Calendar
  const handleResize = () => {
    if (window.innerWidth < 768) {
      setCurrentView("Day")
    } else {
      setCurrentView("Agenda")
    }
  }
  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const [isAutoScrollEnabled, setIsAutoScrollEnabled] = useState(true)
  useEffect(() => {
    // ❌ Do nothing unless conditions are met
    if (!isAutoScrollEnabled || currentView !== "Agenda") {
      return
    }

    const getScrollableContainer = () =>
      document.querySelector(".e-content-wrap") ||
      document.querySelector(".e-schedule-content")

    let container = null
    let interval = null
    let direction = 1
    let isPaused = false

    const SCROLL_STEP = 0.7
    const SCROLL_INTERVAL = 30
    const PAUSE_DURATION = 5000

    const startScroll = () => {
      container = getScrollableContainer()
      if (!container) return

      // 🔑 force scrollable
      container.style.overflowY = "auto"

      // ❌ skip if no overflow
      if (container.scrollHeight <= container.clientHeight + 2) {
        return
      }

      interval = setInterval(() => {
        if (isPaused) return

        const atBottom =
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - 2

        const atTop = container.scrollTop <= 0

        if (direction === 1 && atBottom) {
          isPaused = true
          setTimeout(() => {
            direction = -1
            isPaused = false
          }, PAUSE_DURATION)
          return
        }

        if (direction === -1 && atTop) {
          isPaused = true
          setTimeout(() => {
            direction = 1
            isPaused = false
          }, PAUSE_DURATION)
          return
        }

        container.scrollTop += SCROLL_STEP * direction
      }, SCROLL_INTERVAL)
    }

    // Delay until scheduler renders
    const startTimeout = setTimeout(startScroll, 1200)

    // 🔄 Re-evaluate on resize / zoom
    const handleResize = () => {
      if (interval) clearInterval(interval)
      startScroll()
    }

    window.addEventListener("resize", handleResize)

    return () => {
      clearTimeout(startTimeout)
      if (interval) clearInterval(interval)
      window.removeEventListener("resize", handleResize)
    }
  }, [calendarData, currentView, isAutoScrollEnabled])

useEffect(() => {
  let timer;

  const updateAtMidnight = () => {
    const now = new Date();

    const nextMidnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0,
      0,
      0,
      0
    );

    const timeout =
      nextMidnight.getTime() - now.getTime();

    timer = setTimeout(() => {
      setSelectedDate(new Date());

      // ✅ schedule next midnight again
      updateAtMidnight();

    }, timeout);
  };

  updateAtMidnight();

  return () => {
    if (timer) clearTimeout(timer);
  };

}, []);

  const [scheduleHeight, setScheduleHeight] = useState("100vh")
  useEffect(() => {
    const updateHeight = () => {
      const headerOffset = 200 // adjust if you have navbar / filters
      setScheduleHeight(`${window.innerHeight - headerOffset}px`)
    }

    updateHeight()
    window.addEventListener("resize", updateHeight)

    return () => window.removeEventListener("resize", updateHeight)
  }, [])
  return (
    <div className="m-2 md:m- 10 mt- 24 p- 2 md:p- 10 bg-white rounded-3xl flex-1">
      <div className="flex w-full justify-between">
        <Header title="Calendar" />
        {/* <ButtonComponent id="add" title="Add" onClick={onClickAdd}>
          Create Booking
        </ButtonComponent> */}
        <div>
          {sseConnection ? (
            <ul className="text-red-800 font-bold list-disc">
              <li>Live Update</li>
            </ul>
          ) : (
            <ul className="text-yellow-500 font-bold list-disc">
              <li>Offline</li>
            </ul>
          )}
        </div>
      </div>
      <ButtonComponent
        id="start"
        title="Start"
        onClick={() => {
          setIsAutoScrollEnabled(!isAutoScrollEnabled)
        }}
      >
        {isAutoScrollEnabled ? "Stop Scroll" : "Enable Auto Scroll"}
      </ButtonComponent>
      <ScheduleComponent
        width="100%"
        height={scheduleHeight}
        rowAutoHeight={true}
        selectedDate={selectedDate}
        ref={scheduleObj}
        currentView={currentView}
        eventSettings={{ dataSource: calendarData }}
        editorTemplate={EditorTemplate}
        editorHeaderTemplate={editorHeaderTemplate}
        editorFooterTemplate={editorFooterTemplate}
        showQuickInfo={true}
        eventRendered={onEventRendered}
        popupOpen={onPopupOpen}
        popupClose={onPopupClose}
        // timezone={"UTC"}
        quickInfoTemplates={{
          // header: headerTemplate,
          content: contentTemplate,
          footer: footerTemplate,
        }}
        agendaDaysCount={1}
      >
        <ViewsDirective>
          {["Day", "Week", "WorkWeek", "Month", "Agenda"].map((item) => (
            <ViewDirective key={item} option={item} />
          ))}
        </ViewsDirective>
        <Inject
          services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop]}
        />
      </ScheduleComponent>

      {/* booking form */}
      {isForm ? (
        <>
          <CreateBooking
            data={isData}
            onClick={closeEdit}
            isEdit={isEditData}
          />
        </>
      ) : (
        <></>
      )}

      {isLoading ? (
        <div className="flex justify-center items-center absolute inset-0">
          <div>
            <img src={Loader} alt="" className="w-20" />
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* <PropertyPane>
        <table style={{ width: "100%", background: "white" }}>
          <tbody>
            <tr style={{ height: "50px" }}>
              <td style={{ width: "100%" }}>
                <DatePickerComponent
                  value={new Date()}
                  showClearButton={false}
                  placeholder="Current Date"
                  floatLabelType="Always"
                  change={change}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </PropertyPane> */}
    </div>
  )
}

export default Scheduler
